export default "__VITE_ASSET__D_9BqQQa__"